import React, { useState, useEffect } from "react";
import TimeandDate from "../fields/TimeandDate";
import SelectInput from "../fields/SelectInput";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import TimePickerViewRenderers from "../fields/TimePicker";
import { Switch, Tooltip } from "@mui/material";
import { setWithDriver } from "../../redux/Slice/bookingSlice";

const BookingInformation = ({
  bookingInfo,
  setBookingInfo,
  onChange,
  errmsg,
  setUserInteraction,
  setErrMsg,
}) => {
  const location = useSelector((state) => state?.booking?.location);
  const getCartData = useSelector((state) => state?.car?.getCartData);
  const carId = useSelector((state) => state?.booking?.carId);
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const dispatch = useDispatch();

  function findItemById(array, id) {
    return array.find((item) => item?._id === id);
  }
  const pageData = getCartData && findItemById(getCartData?.data, carId);
  const [checked, setChecked] = useState(null);
  const handleChange = (event) => {
    setChecked(event.target.checked);
    // dispatch(setWithDriver(event.target.checked));
  };
  useEffect(() => {
    if (withDriver === null) {
      setChecked(pageData?.withDriver);
    } else {
      setChecked(withDriver);
    }
  }, []);
  useEffect(() => {
    dispatch(setWithDriver(checked));
  }, [checked]);

  return (
    <div className="card border-0 radio-shadow h-100">
      <h3 className="font card-header border-0 booking-label">
        Booking Information
      </h3>
      <div className="booking-div-space card-body">
        {/* <div className='mb-3' >
                    <SelectInput
                        labelName="Pick-up Location"
                        placeholder="Select location"
                        value={bookingInfo?.pickupLocation}
                        onChange={onChange}
                        options={location}
                        name="pickupLocation"
                        id='pickupLocation'
                        error={!!errmsg?.picklocationErrMsg}
                        helperText={errmsg?.picklocationErrMsg}
                    />
                </div>
                <div className='mb-3' >

                    <SelectInput
                        labelName="Return location"
                        placeholder="Select location"
                        value={bookingInfo?.returnLocation}
                        onChange={onChange}
                        options={location}
                        name="returnLocation"
                        id='returnLocation'
                        error={!!errmsg?.returnlocationErrMsg}
                        helperText={errmsg?.returnlocationErrMsg}
                    />
                </div> */}
        <div className="mb-3">
          {/* <TimePickerViewRenderers value={dayjs()} label="Pick up Time" /> */}
          <TimeandDate
            // defaultValue={today}
            format="DD/MM/YYYY hh:mm a"
            value={bookingInfo?.pickupDate}
            onChange={(newValue) => {
              const date = new Date(newValue.$d);
              setBookingInfo((prevInfo) => ({
                ...prevInfo,
                pickupDate: date,
              }));
              if (setUserInteraction) {
                setUserInteraction(true);
              }
              setErrMsg((prevInfo) => ({
                ...prevInfo,
                pickupDate: "",
              }));
            }}
            name="pickupDate"
            id="pickupDate"
            labelName="Pick up date & time"
            placeholder="select Date and Time"
            error={!!errmsg?.pickupDate}
          />
          {errmsg?.pickupDate ? (
            <p className="location-err">{errmsg?.pickupDate}</p>
          ) : null}
        </div>
        <div className="mb-3">
          <TimeandDate
            // defaultValue={new Date(bookingInfo?.returnDate)}
            format="DD/MM/YYYY hh:mm a"
            value={bookingInfo?.returnDate}
            onChange={(newValue) => {
              const date = new Date(newValue.$d);
              setBookingInfo((prevInfo) => ({
                ...prevInfo,
                returnDate: date,
              }));
              setErrMsg((prevInfo) => ({
                ...prevInfo,
                returnDate: "",
              }));
            }}
            name="returnDate"
            id="returnDate"
            labelName="Return date & time"
            placeholder="select Date and Time"
            error={!!errmsg?.returnDate}
            blockFuture={bookingInfo?.pickupDate}
          />
          {errmsg?.returnDate ? (
            <p className="location-err">{errmsg?.returnDate}</p>
          ) : null}
        </div>
        {/* {pageData?.withDriver ? (
          <div className="mb-3">
            <h6 className="text-secondary m-0 ">With Driver</h6>
            <Tooltip
              title={checked ? "Remove Driver" : "Add Driver"}
            >
              <Switch
                checked={checked}
                onChange={pageData?.withDriver ? handleChange : undefined}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Tooltip>
          </div>
        ) : null} */}
        {/* {pageData?.withDriver ? (
          <div className="mb-3">
            <h6 className="text-secondary m-0 ">With Driver</h6>
            <Tooltip
              title={
                pageData?.withDriver
                  ? checked
                    ? "Remove Driver"
                    : "Add Driver"
                  : "Driver not available with this vehicle"
              }
            >
              <Switch
                checked={checked}
                onChange={pageData?.withDriver ? handleChange : undefined}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Tooltip>
          </div>
        ) : null} */}
      </div>
    </div>
  );
};

export default BookingInformation;
